export default __webpack_public_path__ + "static/cert-icon-10-275a1996cbee82c4c1ee906024b3cf99.png";